var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c10f4be291308194ddca0984944f99f201d69c7f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prod-coataz-app@happylogue"]={id:"c10f4be291308194ddca0984944f99f201d69c7f"};
      